/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';

// Sagas
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import toastr from 'toastr';
import 'toastr/build/toastr.min.css';
import {
  Col, Row, Card, CardBody, CardHeader,
  Button,
} from 'reactstrap';

import {
  Formik, Field, Form, ErrorMessage, FieldArray,
} from 'formik';
import * as Yup from 'yup';

import { get, post } from '../../helpers/api_helper';

document.title = 'TV Utilities';

function Utilities(props) {
  toastr.options = {
    positionClass: 'toast-top-right',
    newestOnTop: true,
  };

  const [miList, setMiList] = useState([]);
  const [miListData, setMiListData] = useState('');

  const { t } = props;

  const loadMiList = async () => {
    try {
      const result = await get('/api/tvs/mi-list');

      setMiList(result);
      setMiListData(result.join('\n'));
    } catch (err) {
      toastr.error(t('Error loading MI list'), t('Error'));
    }
  };

  const saveMiList = async (values) => {
    try {
      await post('/api/tvs/mi-list', values);
      toastr.success(t('MI List saved successfully'));
    } catch (err) {
      toastr.error(t('Error saving MI list'), t('Error'));
    }
  };

  useEffect(() => {
    loadMiList();
  }, []);

  return (
    <div className="page-content">
      <div className="container-fluid">
        <Row>
          <Col sm="4">
            <Card>
              <CardHeader>
                <h5>{t('MI Model List')}</h5>
              </CardHeader>
              <CardBody className="p-4">
                <Formik
                  enableReinitialize
                  initialValues={{ data: miListData }}
                  validationSchema={
                    Yup.object().shape({
                      data: Yup.string().required(t('Required')),
                    })
                  }
                  onSubmit={saveMiList}
                >
                  {({
                    touched, errors, values, setFieldValue,
                  }) => (
                    <Form autoComplete="off" id="mi_list_form">
                      <Field
                        as="textarea"
                        className="form-control"
                        rows="30"
                        cols="30"
                        name="data"
                      />
                    </Form>
                  )}
                </Formik>

                <Button type="submit" form="mi_list_form" color="primary" className="mt-2">{t('Save')}</Button>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

Utilities.defaultProps = {
  t: (x) => (x),
};

Utilities.propTypes = {
  t: PropTypes.any,
};

export default connect(() => ({

}), {})(withTranslation()(Utilities));
